import { render, staticRenderFns } from "./mandateLeft.vue?vue&type=template&id=286da4c0&"
import script from "./mandateLeft.vue?vue&type=script&lang=js&"
export * from "./mandateLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports